<pull-reloading [animation]="pullReloadingAnimation" *ngIf="!theEnd"></pull-reloading>

<div    
    #pullRefresh
    (pan)="panMove($event)"
    (panEnd)="panend($event)"
    class="card-lista-virtual"
    [ngClass]="maxWidth ? 'toda-largura' : ''">

    <!-- <div *ngIf="!listaCotacoes.length && pullReloadingAnimation == 'hide'">
        <h3 class="p-16">Olá! Ainda não tem nenhum pedido de cotação realizado.</h3>
    </div> -->

    <cdk-virtual-scroll-viewport
        itemSize="60"
        (scrolledIndexChange)="nextBatch($event, (listaItems[listaItems.length - 1]))"
        minBufferPx="100"
        maxBufferPx="200"
        [ngClass]="['viewport']">
        <mat-nav-list>
            <mat-list-item *cdkVirtualFor="let item of listaItems; templateCacheSize: 0; let i = index;" class="list-item-virtual-scroll">
                <ng-container *ngTemplateOutlet="templateRef;context:{item: item, index: i}" ></ng-container>
                
                <!-- <ng-container *ngIf="slidingItem">
                    <ng-container *ngTemplateOutlet="templateActionsRef;context:{item: item, index: i}"></ng-container>
                </ng-container> -->
                
                <mat-divider></mat-divider>
            </mat-list-item>        
        </mat-nav-list>
    </cdk-virtual-scroll-viewport>

   
</div>
